import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffects } from './auth.effects';
import { AUTH_FEATURE_KEY, authReducer } from './auth.reducers';

@NgModule({
    imports: [StoreModule.forFeature(AUTH_FEATURE_KEY, authReducer), EffectsModule.forFeature([AuthEffects])]
})
export class AuthStoreModule {}
